<div class="container-fluid p-0 about-fasinating-diamond-main-section">
    <div class="mobile_version-backbutton">
        <a class="mobile-header" onclick="history.back()">
            <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Terms and Conditions</a>
    </div>
    <div class="secure-shopping about-fasinating-diamond">
        <div class="container">
            <div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;">
                <div class="section-title-text text-center pt-4">
                    <h1 class="title">Terms and Conditions</h1>
                </div>
            </div>
            <div class="header-nv terms-tab-view" [ngClass]="{'Scrolled': isScrolled}">
                <div class="list mobile_scroll">
                    <ul>
                        <li>
                            <a [ngClass]="{'active': activeSectionId === 'FindPartner'}"
                                (click)="scrollToSection('FindPartner', $event)">Find A Partner</a>
                        </li>
                        <li>
                            <a [ngClass]="{'active': activeSectionId === 'TPLAcademy'}"
                                (click)="scrollToSection('TPLAcademy', $event)">TPL Academy</a>
                        </li>
                        <li>
                            <a [ngClass]="{'active': activeSectionId === 'TPLTournament'}"
                                (click)="scrollToSection('TPLTournament', $event)">TPL Tournament</a>
                        </li>
                        <li>
                            <a [ngClass]="{'active': activeSectionId === 'TPLStore'}"
                                (click)="scrollToSection('TPLStore', $event)">TPL Store</a>
                        </li>
                        <li>
                            <a [ngClass]="{'active': activeSectionId === 'TPLContest'}"
                                (click)="scrollToSection('TPLContest', $event)">TPL Contest</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div [innerHTML]="cmsContentData" class="section-contain"></div>
        </div>
    </div>
</div>
